import { useMutation, useQueryClient } from "react-query";
import { useUser } from "@/providers/context";
import { AxiosError } from "axios";
import { createPlaylist, CreatePlaylist, PlaylistResponse } from "@/api";

export const useCreatePlaylist = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    PlaylistResponse | undefined,
    AxiosError<{ error: string }>,
    CreatePlaylist
  >(
    async (playlist) => {
      if (uid) {
        return await createPlaylist({ user_id: uid, ...playlist });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["playlists", uid], data);
        }
      },
    },
  );
};
